import { gql } from '@utils/gpl-dedup';

export const logout = gql`
  mutation {
    logout {
      message
      success
    }
  }
`;
